const CardsExperiences = [
    // Basic concierge services
    {
        typology: "basic",
        image: {
            src: require("./images-experiences/shared-amalfi-coast-cruise.jpg"),
            alt: "Shared Amalfi Coast Cruise",
        },
        title: "Shared Amalfi Coast Cruise",
        description: "Sail the Amalfi Coast, explore hidden coves, and create unforgettable memories with fellow travellers.",
        cta: {
            target: "_self",
            text: "VIEW EXPERIENCES",
            link: "#contact-travel-designer",
        },
    },
    {
        typology: "basic",
        image: {            
            src: require("./images-experiences/feeling-italy-food-delivery.jpg"),
            alt: "Feeling Italy Food Delivery",
        },
        title: "Feeling Italy Food Delivery",
        description: "Enjoy authentic Italian flavours delivered fresh to your door—perfect for a cozy night in.",
        cta: {
            target: "_self",
            text: "VIEW EXPERIENCES",
            link: "#contact-travel-designer",
        },
    },
    {
        typology: "basic",
        image: {
            src: require("./images-experiences/shared-tours-of-the-amalfi-coast.jpg"),
            alt: "Shared Tours of the Amalfi Coast",
        },
        title: "Shared Tours of the Amalfi Coast",
        description: "Join like-minded travellers for guided tours that unveil the beauty, history, and charm of the Amalfi Coast.",
        cta: {
            target: "_self",
            text: "VIEW EXPERIENCES",
            link: "#contact-travel-designer",
        },
    },
    {
        typology: "basic",
        image: {
            src: require("./images-experiences/private-transfers.jpg"),
            alt: "Airport & Train Station Pickup",
        },
        title: "Airport & Train Station Pickup",
        description: "Enjoy stress-free travel with our private transfer services, ensuring a smooth journey to your villa.",
        cta: {
            target: "_self",
            text: "VIEW EXPERIENCES",
            link: "#contact-travel-designer",
        },
    },

    // Premium concierge services
    {
        typology: "premium",
        image: {
            src: require("./images-experiences/in-villa-dining-and-private-chef-experiences.jpg"),
            alt: "In Villa Dining & Private Chef",
        },
        title: "In Villa Dining & Private Chef Experiences",
        description: "Elevate your stay with our In Villa Dining & Private Chef Experiences – from authentic Italian dishes to unforgettable pizza nights, all in the comfort of your villa.",
        cta: {
            target: "_self",
            text: "VIEW EXPERIENCES",
            link: "#contact-travel-designer",
        },
    },
    {
        typology: "premium",
        image: {
            src: require("./images-experiences/amalfi-coast-adventures-private-motorboat-and-yacht-cruises.jpg"),
            alt: "Private Motorboat & Yacht Cruises",
        },
        title: "Private Motorboat & Yacht Cruises",
        description: "Explore the breathtaking Amalfi Coast with private motorboat and yacht cruises, offering access to hidden coves, iconic landmarks, and unforgettable views.",
        cta: {
            target: "_self",
            text: "VIEW EXPERIENCES",
            link: "#contact-travel-designer",
        },
    },
    {
        typology: "premium",
        image: {
            src: require("./images-experiences/authentic-pizza-nights-a-taste-of-italy-in-your-villa.jpg"),
            alt: "A Taste of Italy in Your Villa",
        },
        title: "A Taste of Italy in Your Villa",
        description: "Savor freshly made pizzas crafted by expert chefs, right in the comfort of your villa.",
        cta: {
            target: "_self",
            text: "VIEW EXPERIENCES",
            link: "#contact-travel-designer",
        },
    },
    {
        typology: "premium",
        image: {
            src: require("./images-experiences/private-transfers.jpg"),
            alt: "Airport & Train Station Pickup",
        },
        title: "Airport & Train Station Pickup",
        description: "Enjoy stress-free travel with our private transfer services, ensuring a smooth journey to your villa.",
        cta: {
            target: "_self",
            text: "VIEW EXPERIENCES",
            link: "#contact-travel-designer",
        },
    },
];

export default CardsExperiences;
